import { servicePayments } from "../servicePayments";
import { IWorkDefinitionResponse } from "@wingspanhq/payments/dist/interfaces/api/workDefinition";
import { ListRequestQuery } from "../../utils/serviceHelper";

export type ApiQueryPayerEngagementWorkDefinitions = ListRequestQuery<
  undefined,
  {
    createdAt?: "asc" | "desc";
    updatedAt?: "asc" | "desc";
    name?: "asc" | "desc";
  }
>;

export const getPayerEngagementsWorkDefinitions = async (
  {
    payerId,
    engagementId
  }: {
    payerId: string;
    engagementId: string;
  },
  params: ApiQueryPayerEngagementWorkDefinitions
): Promise<Array<IWorkDefinitionResponse>> => {
  const { data } = await servicePayments.get(
    `/payer/${payerId}/engagement/${engagementId}/work-definition`,
    {
      params
    }
  );
  return data;
};
